OH.ShrinkText = function (collection, fontSize, baseWidth, breakpoint) {
  'use strict';

  //親要素の幅に応じて縮小されるテキスト用クラス
  var ShrinkText = function (elem, fz, w, bp) {
    this.item = elem;
    this.baseSize = fz;
    this.baseWidth = w;
    this.breakpoint = bp;
  };
  ShrinkText.prototype = {
    shrink: function (ratio) {  //文字縮小
      //親要素の幅を基準に文字サイズを取得
      var size = Math.round(this.baseSize * ratio);
      //文字サイズ10px以下が指定される場合は10pxにリセット
      this.item.style.fontSize = size < 10 ? 10 : size + 'px';
      return this;
    },
    reset: function () {  //style属性からfont-size指定の削除
      var reg = /font-size:[\s\w]+;/;
      var style = this.item.hasAttribute('style') ? this.item.getAttribute('style') : null;
      if (style === null || style === '') return;
      this.item.setAttribute('style', style.replace(reg, ''));
      return this;
    },
    init: function () { //縮小
      var self = this;
      var resized = function () { //画面幅が変わった際の処理
        var w = parseInt(self.item.parentNode.clientWidth, 10);
        var flg = window.matchMedia(self.breakpoint).matches;
        !flg ? self.shrink(w / self.baseWidth) : self.reset();
      };
      resized();
      //リサイズイベント登録
      window.addEventListener('resize', resized, false);
    }
  };

  var initShrinkText = (function (items, fz, w, bp) {
    Array.prototype.forEach.call(items, function (item) {
      new ShrinkText(item, fz, w, bp).init();
    });
  }(collection, fontSize, baseWidth, breakpoint));
};
